import React from 'react'
import { connect } from 'react-redux';
import SelectBox from 'containers/LoanApplication/components/commons/SelectBox'

class InterestPeriod extends React.Component {

  onChange = (value) => {
    this.props.onChange(value)
  }

  render() {
    const {
      title,
      checked,
    } = this.props;

    return(
      <div>
        <div className='form-group mb-0'>
          <label>{ title }</label>
        </div>
        <div className='row no-gutters mb-3'>
          <div className='col-12 col-sm-3 mr-2'>
            <SelectBox
              checked={ checked == '1' }
              value='1'
              text='1 year'
              onChange={ this.onChange }
             />
          </div>

          <div className='col-12 col-sm-3 mr-2'>
            <SelectBox
              checked={ checked == '3' }
              value='3'
              text='3 years'
              onChange={ this.onChange }
             />
          </div>

          <div className='col-12 col-sm-3 mr-2'>
            <SelectBox
              checked={ checked == '5' }
              value='5'
              text='5 years'
              onChange={ this.onChange }
             />
          </div>
        </div>
      </div>
    )
  }
}

export default InterestPeriod;
